import { useImagePreloader } from "@/hooks/useImagePreloader";

// This is the implementation file to change the description of the organization type and its image

interface OrganizationalStructure {
  value: string;
  label: string;
  description: string;
  image: string;
}
interface OrganizationalStructureProps {
  selectedStructure: string;
  organizationalStructures: OrganizationalStructure[];
}
export const OrganizationalStructure = ({
  selectedStructure,
  organizationalStructures
}: OrganizationalStructureProps) => {
  // Preload all organization structure images
  const imageUrls = organizationalStructures.map(structure => `/images/organization-structures/${structure.image}`);
  const {
    loadedImages
  } = useImagePreloader({
    images: imageUrls
  });
  const selectedStructureDetails = selectedStructure ? organizationalStructures.find(s => s.value === selectedStructure) : null;
  
  return <div className="bg-secondary/50 backdrop-blur-lg border-2 border-primary rounded-lg shadow-lg shadow-purple-500/10 p-4 pt-6 h-full flex flex-col transition-all duration-300 hover:shadow-emerald-500/20">
      <h3 className="text-xl font-semibold mb-0 py-2 text-white">Organizational Structure</h3>
      <div className="space-y-4 flex-1 overflow-auto">
        {selectedStructureDetails && <div className="bg-primary/5 border border-primary p-2 rounded-lg animate-fade-in">
            <p className="text-gray-300 text-[12px] leading-relaxed">
              <span className="text-primary text-[12px] font-bold">{selectedStructureDetails.label}: </span>
              {selectedStructureDetails.description}
            </p>
          </div>}

        {selectedStructureDetails && <div className="animate-fade-in flex-1 flex flex-col justify-center mt-12">
            <img src={`/images/organization-structures/${selectedStructureDetails.image}`} alt={`${selectedStructureDetails.label} visualization`} className="w-full rounded-lg shadow-md object-cover aspect-video border border-emerald-500/20" style={{
          opacity: loadedImages.has(`/images/organization-structures/${selectedStructureDetails.image}`) ? 1 : 0.7,
          transition: 'opacity 0.3s ease-in-out'
        }} />
          </div>}
      </div>
    </div>;
};